import { getDispatcherUrl } from 'modules/utils/UrlUtils';
import {
  DispatcherCategoryService,
  DispatcherAuthPrefix,
  DispatcherResource,
  DispatcherEndpoint
} from 'modules/types/common';

export type MedicalHistoryEndpointGenerator = (
  endpoint?: DispatcherEndpoint | string,
  needsBase?: boolean
) => string;
/**
 * Creates an endpoint generator based on the dispatcher category/resource
 * @summary shared by all medical history sub categories.
 * @param {DispatcherResource} resource the resource for which to generate endpoints.
 * @returns the medical history endpoint generator
 */
export function getMedicalHistoryEndpointGenerator(
  resource: DispatcherResource
): MedicalHistoryEndpointGenerator {
  /**
   * Gets the medical history endpoint based on the action specified
   * @summary (not the fully qualified URL)
   * @param {DispatcherEndpoint | string} endpoint the endpoint/action for which to generate an endpoint.
   * @param {boolean} needsBase whether or not the base url should also be returned.
   * @returns an endpoint for the medical history action, or a default (if the action is not specified).
   */
  return (endpoint: DispatcherEndpoint | string = '', needsBase = false) => {
    return getDispatcherUrl(
      DispatcherCategoryService.HEALTH_RECORDS,
      DispatcherAuthPrefix.AUTHENTICATED,
      resource,
      endpoint,
      needsBase
    );
  };
}
